import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import { Field, useFormik } from "formik";
import * as Yup from "yup";
import { Box, Checkbox, Chip, Divider, FormControl, FormLabel, Grid, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { createRole, fetchPermissions, updateRole } from '../../store/roleSlice';
import CommentDrawer from '../Common/Drawer';

export default function RoleForm({ getRoles,page, setPage,title, roleModal, setRoleModal, selectedRole = null }) {
console.log("page",page);

    const permissionsData = useSelector((state) => state.roleReducer.permissionsData)
    const [isButtonDisabled, setIsButtonDisabled] = React.useState();
    const [selectedRoleVal, setSelectedRolVal] = React.useState();

    const dispatch = useDispatch()
    const validationSchema = Yup.object({
        name: Yup.string()
            .required("Role name is required")
            .min(3, "Role name must be at least 3 characters").max(50, "Role name should not be greater than 50 character"),
    });
    const formik = useFormik({
        initialValues: {
            name: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            console.log("Form Submitted:", values);
            setRoleModal(false)

            const updatedPermissions = Object.entries(values).reduce((acc, [model_name, selectedValue]) => {
                let permissions = [];
                console.log("selectedValue", selectedValue);

                if (model_name !== "name") {
                    switch (selectedValue) {
                        case "full_access":
                            permissions = ["view", "add", "change", "delete"];
                            break;
                        case "view_only":
                            permissions = ["view"];
                            break;
                        case "add_update":
                            permissions = ["add", "change","view"];
                            break;
                        // case "none":
                        //     permissions = [];
                        //     break;
                        default:
                            permissions = [];
                            break;
                    }
                }
                if (model_name !== "name")
                    acc[model_name] = permissions;
                return acc;
            }, {});

            values.permissions = updatedPermissions;
            console.log("values", values);

            if (selectedRole) {
                values.id = selectedRole.id
                dispatch(updateRole(values)).then(()=>{

                    getRoles()
                })
            } else {
                dispatch(createRole(values)).then(()=>{
                    if(page>0){
                        setPage(0)                        
                    }else{
                        getRoles()
                    }
                })
            }
        },
    });
    const handleClose = () => {
        setRoleModal(false);
    };

    useEffect(() => {
        dispatch(fetchPermissions())
        if (!selectedRole)
            formik.resetForm();

    }, [roleModal])
    useEffect(() => {
        if (selectedRole?.permissions?.assigned_permissions) {
            formik.resetForm();
            const assignedPermissionsMap = {};

            selectedRole.permissions.assigned_permissions.forEach(({ model_name, permissions }) => {
                let permissionValue = "none"; // Default value

                if (permissions.includes("view") && permissions.includes("add") && permissions.includes("change") && permissions.includes("delete")) {
                    permissionValue = "full_access";
                } else if (permissions.includes("view") && !permissions.includes("add") && !permissions.includes("change")) {
                    permissionValue = "view_only";
                } else if (permissions.includes("add") || permissions.includes("change")) {
                    permissionValue = "add_update";
                }
                assignedPermissionsMap[model_name] = permissionValue;
            });
            formik.setFieldValue("name", selectedRole.name);
            Object.entries(assignedPermissionsMap).forEach(([key, value]) => {
                formik.setFieldValue(key, value);
            });
            setSelectedRolVal(formik.values)
        }
        if (!selectedRole && permissionsData.length > 0) {
            const defaultValues = { name: "" };
            permissionsData.forEach(({ model_name }) => {
                defaultValues[model_name] = "view_only"; // Set default permission
            });
            formik.setValues(defaultValues);
        }
    
    }, [selectedRole, roleModal]);


    useEffect(() => {

        if (selectedRole) {
            const disabled = JSON.stringify(formik.values) === JSON.stringify(selectedRoleVal);
            setIsButtonDisabled(disabled)
        }
        setSelectedRolVal(formik.values)

    }, [selectedRole, formik.values])
    
    if (roleModal)
        return (
            <>

                <CommentDrawer open={roleModal} setOpen={setRoleModal} >

                    <Grid size={{ lg: 3, md: 6, sm: 12, xs: 12 }} >
                        <Box
                            component="form"
                            // onSubmit={formik.handleSubmit}
                            className='full-height'
                        >
                            <Typography variant="h6" gutterBottom className='p-3'>
                                {title}
                            </Typography>
                            <Divider />
                            <div className='role-form-scroller px-3'>
                                <TextField
                                    fullWidth
                                    required
                                    id="name"
                                    label="Role Name"
                                    margin="normal"
                                    variant="outlined"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.name && Boolean(formik.errors.name)}
                                    helperText={formik.touched.name && formik.errors.name}
                                />
                                {/* <Typography className='mt-1'>Module Permissions</Typography> */}

                                {permissionsData.map(({ model_name, display_name }, index) => (
                                    <Box className="d-flex justify-content-between align-items-center" key={model_name}>
                                        <Typography className='font-weight'>

                                            {display_name
                                                .split(' ')  // Split the display name into an array of words
                                                .map(word =>
                                                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitalize first letter of each word
                                                )
                                                .join(' ')}
                                        </Typography>
                                        <FormControl key={index} margin="normal"  >
                                            <ToggleButtonGroup
                                                exclusive // Ensures only one can be selected at a time
                                                value={formik.values[model_name] || ""} // Default to empty string instead of an array
                                                onChange={(event, newValue) => formik.setFieldValue(model_name, newValue)}
                                                aria-label={display_name}
                                            >
                                                {["full_access", "view_only", "add_update"].map((perm) => (
                                                    <ToggleButton key={perm} value={perm}>
                                                        {perm
                                                            .split('_') // Split by underscores
                                                            .map(word =>
                                                                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitalize first letter of each word
                                                            )
                                                            .join(' ')}
                                                    </ToggleButton>
                                                ))}
                                            </ToggleButtonGroup>
                                        </FormControl>
                                    </Box>

                                ))}
                            </div>
                            <Box className="drawer-footer m-3">
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="primary"
                                    onClick={handleClose}
                                    className="mt-2 mr-2"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    className="mt-2"
                                    disabled={selectedRole ? (isButtonDisabled || !formik.isValid) : !(formik.dirty && formik.isValid)}
                                    onClick={formik.handleSubmit}
                                >
                                    Save
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                </CommentDrawer >

            </>
        );
}